import axios from 'axios'
import portfolioService from '@/services/portfolioService'
import {apiToPortfolio} from './converters'

const API_V1_URL = process.env.API_V1_URL

export default {
  ...portfolioService,
  createPortfolio(userId, portfolioId) {
    const portfolio = {
      id: portfolioId,
      userId,
    }
    return axios.post(API_V1_URL + '/portfolios', portfolio)
      .then(res => res.data.id)
      .catch(errObj => Promise.reject(errObj.response.data.error))
  },
  getTotalPortfolios() {
    return axios.get(API_V1_URL + '/portfolio')
      .then(res => apiToPortfolio(res.data))
      .catch(errObj => Promise.reject(errObj.response.data.error))
  },
  deleteAllTransactions() {
    return axios.delete(API_V1_URL + '/tx')
      .catch(errObj => Promise.reject(errObj.response.data.error))
  },
  exportAllTransactions() {
    return axios.get(API_V1_URL + '/tx/listall')
      .then(res => res.data)
      .catch(errObj => Promise.reject(errObj.response.data.error))
  },
}



// WEBPACK FOOTER //
// ./src/-service-app/services/portfolioService.js